// in src/User.js
import * as React from "react";
// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Create,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  ImageField,
  ImageInput,
  NumberField,
  NumberInput,
} from "react-admin";
import { CustomDeleteButton } from './CustomDeleteButtons';

const UserFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="email" alwaysOn />
  </Filter>
);

export const UserList = (props) => (
  <List {...props} filters={<UserFilter />}>
    <Datagrid>
      <TextField source="email" label="Email" />
      <TextField source="bio" label="Bio" />
      <NumberField source="slh" label="SLH Score" />
      <ShowButton label="" />
      <EditButton label="" />
      <CustomDeleteButton label="" redirect={false}/>
    </Datagrid>
  </List>
);

export const UserShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <TextField source="email" label="Email" />
      <ImageField source="profile_photo" label="Profile Photo" />
      <TextField source="bio" label="Bio" />
      <NumberField source="slh" label="SLH Score" />
    </SimpleShowLayout>
  </Show>
);

export const UserCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="email" label="Email" />
      <TextInput source="password" label="Password" type="password" />
      <ImageInput source="profile_photo" label="Profile Photo" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>
      <TextInput source="bio" label="Bio" multiline />
      <NumberInput source="slh" label="SLH Score" />
    </SimpleForm>
  </Create>
);

export const UserEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="email" label="Email" />
      <TextInput source="password" label="New Password" type="password" />
      <ImageInput source="profile_photo" label="Profile Photo" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>
      <TextInput source="bio" label="Bio" multiline />
      <NumberInput source="slh" label="SLH Score" />
    </SimpleForm>
  </Edit>
);
